import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allUsersKonsole } from 'app/mocks/data/users/konsole'

import { api } from 'app/utils/constants'

import { KonsoleUser } from 'app/types/users/konsole'

export const getUserKonsole = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.konsole.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const userKonsoleFound = allUsersKonsole.find(
            (user) => user.id.toString() === id,
        )

        // Not found
        if (!userKonsoleFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<KonsoleUser>(userKonsoleFound)
    },
)
